import { FileImportRecord } from '@app/ftp/ftp-api.model';
import {
  GettingStartedButtonInfo,
  GettingStartedStates,
  QuickLinks,
} from './skills-dashboard.model';

export const DASHBOARD_CONSTANTS = {
  gettingStartedViewState: {
    PublishedSkills: 'PublishedSkills',
    AddSource: 'AddSource',
    UploadSkills: 'UploadSkills',
    ReviewSuggestionsAndPublishSkills: 'ReviewSuggestionsAndPublishSkills',
  },

  CTA_WIDGETS: {
    SKILLS_SUGGESTIONS: 'SkillsSuggestions',
    UNPUBLISHED_SKILLS: 'UnpublishedSkills',
  },
  QUICK_LINKS: [
    {
      label: 'Core_Inventory',
      path: ['skill-inventory'],
    },
    {
      label: 'Core_Sources',
      path: ['skill-sources'],
    },
    {
      label: 'OrgSkillsNav_Roles',
      path: ['skills', 'roles'],
    },
    {
      label: 'Core_Categories',
      path: ['categories'],
    },
  ],
};

export const prepareButtonState = (
  info: GettingStartedStates,
  translate: (defaultString: string, key: string, values?: object) => string
): GettingStartedButtonInfo[] => {
  const buttons: GettingStartedButtonInfo[] = [];
  switch (info.state) {
    case DASHBOARD_CONSTANTS.gettingStartedViewState.AddSource:
      buttons.push({
        label: translate(
          'Add Primary Skill Source',
          'SkillsSvc_AddPrimarySkillSource'
        ),
        type: 'primary',
        path: ['../../', 'skill-sources', 'create'],
        queryParams: { isNetNew: true },
      });
      break;

    case DASHBOARD_CONSTANTS.gettingStartedViewState.UploadSkills:
      buttons.push({
        label: translate(
          'Upload Skills to {{SourceName}}',
          'OrgSkills_UploadSkills_ToSource',
          { SourceName: info.sourceName }
        ),
        type: 'primary',
        path: ['../../', 'skill-sources', 'details', info.sourceId],
      });
      break;

    case DASHBOARD_CONSTANTS.gettingStartedViewState
      .ReviewSuggestionsAndPublishSkills:
      if (info.reviewSuggestions) {
        buttons.push({
          label: translate('Review Suggestions', 'SkillsSvc_ReviewSuggestions'),
          type: 'primary',
          path: ['../../', 'skill-suggestions'],
        });
      }
      buttons.push({
        label: translate(
          'Publish {{publishSkillCount}} Skills',
          'SkillsSvc_PublishSkillCount',
          { publishSkillCount: info.publishSkillsCount }
        ),
        type: info.reviewSuggestions ? 'secondary' : 'primary',
        path: ['../../', 'publish-skills'],
      });
      break;
  }
  return buttons;
};

export const transformQuickLinksPath = (): QuickLinks[] => {
  const QUICK_LINKS = DASHBOARD_CONSTANTS.QUICK_LINKS;
  return QUICK_LINKS.map((link) => ({
    ...link,
    path: link.path.includes(QUICK_LINKS[2].path[1])
      ? ['../../', ...link.path]
      : ['../', ...link.path],
  }));
};

//return true if any of the file is in processing state
export const ShowBannerInfo = (
  records: FileImportRecord[],
  fileTypes: string[]
): boolean =>
  records.some(
    (record) =>
      fileTypes.includes(record.fileType) && record.status === 'Processing'
  );
